module.exports = __webpack_public_path__ + "img/edge_activites_accrobranche.4ad78427.svg";